













































import { EventJson } from 'inscreva-sse-models';
import { Component, Vue } from 'vue-property-decorator';

import { sessionStore } from '@/store/session';

import { Event } from '../models/event';
import BaseSidebar from './base/Sidebar.vue';
import EventListModal from './EventListModal.vue';

export type CommonMenu = {
  title: string;
  icon?: string;
};
export type MenuLink = CommonMenu & {
  path: string;
};
export type ActionMenu = CommonMenu & {
  onClick: () => void;
};
export type Menu = MenuLink | ActionMenu;
@Component({
  components: {
    BaseSidebar,
    EventListModal,
  },
})
export default class SidebarComponent extends Vue {
  // Refs
  private baseSideBar!: BaseSidebar;

  private eventModal!: EventListModal;

  get event(): Event {
    const isEventFromTheSelectedCompany: boolean =
      sessionStore.session?.company.publicKey === sessionStore.session?.event?.idCompany;
    return isEventFromTheSelectedCompany && EventJson.fromJson(sessionStore.session.event);
  }

  mounted() {
    this.baseSideBar = this.$refs.sidebar as BaseSidebar;
    this.eventModal = this.$refs.eventModal as EventListModal;
  }

  toggleSidebar() {
    this.baseSideBar.toggleSidebar();
  }

  openEventSelectionModal() {
    this.eventModal.open();
  }

  isMenuLink(menu: Menu): menu is MenuLink {
    return !!(menu as MenuLink).path;
  }

  onMenuClick(menu: Menu) {
    this.isMenuLink(menu) ? this.$router.push({ path: menu.path, append: false }) : menu.onClick();
  }
}
